import {CategoryAssociationModel} from '../models/category-association.model';
import {ApiService} from './api.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class CategoryAssociationsService {

  constructor(private apiService: ApiService) {}

  list(): Observable<CategoryAssociationModel[]> {
    return this.apiService.get('/gandadmin/assoc_categories');
  }

  findById(id: number): Observable<CategoryAssociationModel> {
    return this.apiService.get('/assoc_categories/' + id);
  }

  create(association: CategoryAssociationModel, category: number): Observable<CategoryAssociationModel> {
    return this.apiService.post('/gandadmin/assoc_categories/new',
      {
        assoc_category: {
          name: association.name,
          description: association.description
        }
      });
  }

  update(category: CategoryAssociationModel): Observable<CategoryAssociationModel> {
    return this.apiService.put('/gandadmin/assoc_categories/' + category.id,
      {
        assoc_category: {
          name: category.name,
          description: category.description
        }
      });
  }

  activateOrDeactivate(category: CategoryAssociationModel): Observable<CategoryAssociationModel> {
    const verb = category.is_active ? 'deactivate' : 'activate';
    return this.apiService.post('/gandadmin/assoc_categories/' + category.id + '/' + verb);
  }
}
